import { Flex, Icon, Tooltip, Typography } from "@ugc-ui/lego";
import React from "react";
import { observer } from "mobx-react-lite";
import { IconContainer } from "@common/components/Statistic/ChartCustomTooltip.styled";

type Props = {
  creationDate: string;
  startDate?: string;
  endDate?: string;
};

export const GeneralInfo = observer(
  ({ creationDate, startDate, endDate }: Props) => (
    <Flex justifyContent="space-between">
      <Flex flexDirection="column" gap={2}>
        <Typography
          color="#8E8E93"
          type="tablecaption"
          style={{ fontWeight: "normal", height: 16 }}
        >
          Создана
        </Typography>
        <Typography color="#DFDFDF" type="tablebody">
          {creationDate}
        </Typography>
      </Flex>
      {startDate && (
        <Flex flexDirection="column" gap={2}>
          <Typography
            color="#8E8E93"
            type="tablecaption"
            style={{ fontWeight: "normal", height: 16 }}
          >
            Запущена
          </Typography>
          <Typography color="#DFDFDF" type="tablebody">
            {startDate}
          </Typography>
        </Flex>
      )}
      {endDate && (
        <Flex flexDirection="column" gap={2}>
          <Flex gap={5}>
            <Typography
              color="#8E8E93"
              type="tablecaption"
              style={{ fontWeight: "normal" }}
            >
              Завершится
            </Typography>
            <Tooltip
              title="Указана предполагаемая дата окончания кампании, основанная на изменении параметра скорости показов в минуту."
              color="default"
              placement="bottomLeft"
              className="date-end-tooltip-text"
            >
              <IconContainer>
                <Icon icon="help" size="extraSmall" color="#8E8E93" />
              </IconContainer>
            </Tooltip>
          </Flex>
          <Typography color="#DFDFDF" type="tablebody">
            {endDate}
          </Typography>
        </Flex>
      )}
    </Flex>
  )
);
